import React, { useEffect, useState } from "react";
import axios from "axios";

import CreatableSelect from "react-select/creatable";

const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ""),
});

const StoreSelect = ({
  className,
  field,
  form,
  styles,
  placeholder,
  disabled,
  defaultOptions,
  onSelectionChange,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(defaultOptions ?? []);
  const [value, setValue] = useState();

  const onChange = (option) => {
    // isClearable: the × / Backspace sends null.
    setTimeout(() => form?.setFieldValue(field?.name, option?.id ?? null), 0);
    setValue(option ?? null);

    const item = option ? options.find((item) => item.id === option.id) : null;
    onSelectionChange && onSelectionChange(item);
  };

  const selectProps = {
    className: className || "select-container",
    classNamePrefix: "select",
    onChange,
    placeholder,
    name: field?.name,
    styles: {
      menuPortal: (base) => ({ ...base, zIndex: 9999999999999 }),
      ...styles,
    },
  };

  const handleCreate = async (inputValue) => {
    setIsLoading(true);
    const { data } = await axios.post("/api/stores", { name: inputValue });
    const newOption = { id: data.id, name: data.name };
    form?.setFieldValue(field?.name, data.id);
    setOptions((prev) => [...prev, newOption]);
    setValue(newOption);
    setIsLoading(false);
  };

  const fetchStores = async () => {
    try {
      const { data } = await axios.get("/api/stores");
      setOptions(data);
      if (field?.value) {
        const initialValue = data.find((item) => item.id === field.value);
        setValue(initialValue ?? null);
      }
    } catch (error) {
      console.error("Error fetching stores:", error);
    }
  };

  useEffect(() => {
    if (field?.value) {
      const selectedOption = options.find(
        (option) => option.id === field.value
      );
      setValue(selectedOption ?? null);
    }
  }, [field?.value]);

  useEffect(() => {
    fetchStores();
  }, []);

  return (
    <CreatableSelect
      isClearable
      isDisabled={disabled}
      isLoading={isLoading}
      onCreateOption={handleCreate}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      formatCreateLabel={(input) => "Confirm: " + input}
      getNewOptionData={(inputValue, optionLabel) => {
        return {
          id: optionLabel,
          name: optionLabel,
        };
      }}
      options={options}
      value={value}
      {...selectProps}
    />
  );
};

export default StoreSelect;
